__turbopack_context__.v({
  "noIconMargins": "TransportationModeFilter-module__vyXJLq__noIconMargins",
});
